import Vue from 'vue';
import Router from 'vue-router';
import {util} from "./utils/util";
import env from '@/utils/env'
import VueCookies from 'vue-cookies'

Vue.use(Router);
Vue.use(VueCookies);



const routes = [
  {
    name: 'home/index',
    component: () => import('./pages/home/index.vue'),
    meta: {
      title: '首页',
      showTab:true,
      keepAlive:true,
      show_wyplayer: true
    }
  },
  {
    name: 'learning_center/center',
    component: () => import('./pages/learning_center/center.vue'),
    meta: {
      title: '学习中心',
      showTab:true,
      keepAlive:true
    }
  },
  {
    name: 'user/index',
    component: () => import('./pages/user/index.vue'),
    meta: {
      title: '我的',
      showTab:true,
      keepAlive:true
    }
  },
  {
    name: 'curriculum/index',
    component: () => import('./pages/curriculum/index.vue'),
    meta: {
      title: '课程详情',
      keepAlive: true,
      show_wyplayer: false,
    }
  },
  {
    name: 'integral/index',
    component: () => import('./pages/integral/index.vue'),
    meta: {
      title: '排行',
    }
  },
  {
    name: 'learning_center/datas',
    component: () => import('./pages/learning_center/datas.vue'),
    meta: {
      title: '学习数据',
    }
  },
  {
    name: 'more_list/index',
    component: () => import('./pages/more_list/index.vue'),
    meta: {
      title: '更多',
    }
  },
  {
    name: 'more_list/replys',
    component: () => import('./pages/more_list/replys.vue'),
    meta: {
      title: '讨论区',
    }
  },
  {
    name: 'more_single_list/index',
    component: () => import('./pages/more_single_list/index.vue'),
    meta: {
      title: '更多',
    }
  },
  {
    name: 'more_time_table/index',
    component: () => import('./pages/more_time_table/index.vue'),
    meta: {
      title: '更多',
    }
  },
  {
    name: 'user/info',
    component: () => import('./pages/user/info.vue'),
    meta: {
      title: '我的'
    }
  },
  {
    name: 'user/about',
    component: () => import('./pages/user/about.vue'),
    meta: {
      title: '关于我们'
    }
  },
  {
    name: 'user/login',
    component: () => import('./pages/user/login.vue'),
    meta: {
      title: '登录授权',
    }
  },
  {
    name: 'user/merge',
    component: () => import('./pages/user/merge.vue'),
    meta: {
      title: '账号合并',
    }
  },
  {
    name: 'user/mergres',
    component: () => import('./pages/user/mergres.vue'),
    meta: {
      title: '合并结果',
    }
  },
  {
    name: 'user/mobile',
    component: () => import('./pages/user/mobile.vue'),
    meta: {
      title: '手机号码',
    }
  },
  {
    name: 'integral_detail/index',
    component: () => import('./pages/integral_detail/index.vue'),
    meta: {
      title: '我的分享',
    }
  },
  {
    name: 'my_collect/index',
    component: () => import('./pages/my_collect/index.vue'),
    meta: {
      title: '我的收藏',
    }
  },
  {
    name: 'play_record/index',
    component: () => import('./pages/play_record/index.vue'),
    meta: {
      title: '播放记录',
    }
  },
  {
    name: 'my_share/index',
    component: () => import('./pages/my_share/index.vue'),
    meta: {
      title: '推广大使',
    }
  },
  {
    name: 'time_table_detail/index',
    component: () => import('./pages/time_table_detail/index.vue'),
    meta: {
      title: '排课',
    }
  },
  {
    name: 'collect_info/index',
    component: () => import('./pages/collect_info/index.vue'),
    meta: {
      title: '活动报名',
    }
  },
  {
    name: 'course_task/index',
    component: () => import('./pages/course_task/index.vue'),
    meta: {
      title: '课程作业',
    }
  },
  {
    name: 'course_task/mytask',
    component: () => import('./pages/course_task/mytask.vue'),
    meta: {
      title: '我的作业'
    }
  },
  {
    name: 'course_task/detail',
    component: () => import('./pages/course_task/detail.vue'),
    meta: {
      title: '作业详情',
    }
  },
  {
    name: 'course_task/answer_detail',
    component: () => import('./pages/course_task/answer_detail.vue'),
    meta: {
      title: '作业回答详情',
    }
  },
  {
    name: 'course_task/edit',
    component: () => import('./pages/course_task/edit.vue'),
    meta: {
      title: '作业详情',
    }
  },
  {
    name: 'forward/info',
    component: () => import('./pages/forward/info.vue'),
    meta: {
      title: '转发',
    }
  },
  {
    name: 'we_chat_back/index',
    component: () => import('./pages/we_chat_back/index.vue'),
    meta: {
      title: '跳转中...'
    }
  },
  {
    name: 'payment/index',
    component: () => import('./pages/payment/index.vue'),
    meta: {
      title: '支付'
    }
  },
  {
    name: 'coupon/index',
    component: () => import('./pages/coupon/index.vue'),
    meta: {
      title: '优惠券'
    }
  },
  {
    name: 'coupon/detail',
    component: () => import('./pages/coupon/detail.vue'),
    meta: {
      title: '优惠券详情'
    }
  },
  {
    name: 'coupon/coupon_course',
    component: () => import('./pages/coupon/coupon_course.vue'),
    meta: {
      title: '课程列表',
    }
  },
  {
    name: 'coupon/coupon_training',
    component: () => import('./pages/coupon/coupon_training.vue'),
    meta: {
      title: '训练营列表',
    }
  },
  {
    name: 'coupon/coupon_list',
    component: () => import('./pages/coupon/coupon_list.vue'),
    meta: {
      title: '所有优惠券',
    }
  },
  {
    name: 'coupon/my_coupon',
    component: () => import('./pages/coupon/my_coupon.vue'),
    meta: {
      title: '我的优惠券',
    }
  },
  {
    name: 'learning_center/index',
    component: () => import('./pages/learning_center/index.vue'),
    meta: {
      title: '学习中心',
    }
  },
  {
    name: 'search/index',
    component: () => import('./pages/search/index.vue'),
    meta: {
      title: '搜索',
    }
  },
  {
    name: 'testing/index',
    component: () => import('./pages/testing/index.vue'),
    meta: {
      title: '考试详情'
    }
  },
  {
    name: 'testing/answered',
    component: () => import('./pages/testing/answered.vue'),
    meta: {
      title: '考试答卷'
    }
  },
  {
    name: 'testing/mytesting',
    component: () => import('./pages/testing/mytesting.vue'),
    meta: {
      title: '我的考试'
    }
  },
  {
    name: 'news/index',
    component: () => import('./pages/news/index.vue'),
    meta: {
      title: '消息',
      keepAlive:true
    }
  },
  {
    name: 'course_task/comment_detail',
    component: () => import('./pages/course_task/comment_detail.vue'),
    meta: {
      title: '评论详情'
    }
  },
  {
    name: 'question/index',
    component: () => import('./pages/question/index.vue'),
    meta: {
      title: '随测列表'
    }
  },
  {
    name: 'question/detail',
    component: () => import('./pages/question/detail.vue'),
    meta: {
      title: '随测详情'
    }
  },
  {
    name: 'live/index',
    component: () => import('./pages/live/index.vue'),
    meta: {
      title: '直播详情',
      show_wyplayer: false
    }
  },
  {
    name: 'knowledge_map/index',
    component: () => import('./pages/knowledge_map/index.vue'),
    meta: {
      title: '知识地图',
    }
  },
  {
    name: 'knowledge_map/tindex/:knowledge_map_id',
    component: () => import('./pages/knowledge_map/index.vue'),
    meta: {
      title: '知识地图',
      showTab:true,
      keepAlive:true
    }
  },
  {
    name: 'knowledge_map/tindex',
    component: () => import('./pages/knowledge_map/index.vue'),
    meta: {
      title: '知识地图',
      showTab:true,
      keepAlive:true
    }
  },
  {
    name: 'discuss/detail',
    component: () => import('./pages/discuss/detail.vue'),
    meta: {
      title: '讨论详情'
    }
  },
  {
    name: 'training/index',
    component: () => import('./pages/training/index.vue'),
    meta: {
      title: '训练营',
    }
  },
  {
    name: 'training/phase',
    component: () => import('./pages/training/phase.vue'),
    meta: {
      title: '营期',
      show_wyplayer: false,
    }
  },
  {
    name: 'training/students',
    component: () => import('./pages/training/students.vue'),
    meta: {
      title: '关注的同学',
    }
  },
  {
    name: 'training/report',
    component: () => import('./pages/training/report.vue'),
    meta: {
      title: '成绩单',
    }
  },
  {
    name: 'training/testing',
    component: () => import('./pages/training/testing.vue'),
    meta: {
      title: '训练营考试详情'
    }
  },
  {
    name: 'training/answered',
    component: () => import('./pages/training/answered.vue'),
    meta: {
      title: '训练营考试回答'
    }
  },
  {
    name: 'training/curriculum',
    component: () => import('./pages/training/curriculum.vue'),
    meta: {
      title: '训练营考试详情'
    }
  },
  {
    name: 'training/exercise',
    component: () => import('./pages/training/exercise.vue'),
    meta: {
      title: '训练营练习'
    }
  },
  {
    name: 'training/live',
    component: () => import('./pages/training/live.vue'),
    meta: {
      title: '训练营直播'
    }
  },
  {
    name: 'micro/index',
    component: () => import('./pages/micro/index.vue'),
    meta: {
      title: '小视频',
      showTab:true,
      keepAlive:true,
      transition:true,
    }
  },
  {
    name: 'micro/serial',
    component: () => import('./pages/micro/serial.vue'),
    meta: {
      title: '系列',
      showTab:false,
      transition:true,
    }
  },
  {
    name: 'micro/single',
    component: () => import('./pages/micro/index.vue'),
    meta: {
      title: '小视频',
      showTab:false,
    }
  },
  {
    name: 'micro/assign',
    component: () => import('./pages/micro/index.vue'),
    meta: {
      title: '小视频',
      showTab:false,
    }
  },
  {
    name: 'fm/index',
    component: () => import('./pages/fm/index.vue'),
    meta: {
      title: 'FM频道',
      showTab:false,
      show_wyplayer: false,
      keepAlive:true,
    }
  },
  {
    name: 'fm/index2',
    component: () => import('./pages/fm/index2.vue'),
    meta: {
      title: 'FM频道2',
      showTab:false,
    }
  },
  {
    name: 'fm/users',
    component: () => import('./pages/fm/users.vue'),
    meta: {
      title: '收听学员',
      showTab:false,
    }
  },
  {
    name: 'portrayal/index',
    component: () => import('./pages/portrayal/index.vue'),
    meta: {
      title: '职业画像',
      showTab:false,
    }
  },
  {
    name: 'portrayal/check',
    component: () => import('./pages/portrayal/check.vue'),
    meta: {
      title: '任务项检测',
      showTab:false,
    }
  },
  {
    name: 'yjy/login',
    component: () => import('./pages/yjy/login.vue'),
    meta: {
      title: '学生登录',// 学生登录
      showTab:false,
    }
  },
  {
    name: 'yjy/authorization',
    component: () => import('./pages/yjy/authorization.vue'),
    meta: {
      title: '学生授权',// 学生授权
      showTab:false,
    }
  },
  {
    name: 'errors/index',
    component: () => import('./pages/errors/index.vue'),
    meta: {
      title: '提示信息'
    }
  },
  {
    name: 'errors/audit',
    component: () => import('./pages/errors/audit.vue'),
    meta: {
      title: '账号正在审核中'
    }
  },
  {
    name: 'test/index',
    component: () => import('./pages/test/index.vue'),
    meta: {
      title: '实验室'
    }
  },
  {
    name: 'test/epindex',
    component: () => import('./pages/test/epindex.vue'),
    meta: {
      title: '测试企业微信授权',
      showTab:true,
      keepAlive:true,
    }
  },
  {
    name: 'test/video',
    component: () => import('./pages/test/video.vue'),
    meta: {
      title: '视频测试'
    }
  },
  {
    name: 'test/audio',
    component: () => import('./pages/test/audio.vue'),
    meta: {
      title: 'FM测试'
    }
  },
  {
    name: 'test/wxvideo',
    component: () => import('./pages/test/wxvideo.vue'),
    meta: {
      title: '微信播放器'
    }
  },
  {
    name: 'test/wxvideo',
    component: () => import('./pages/test/wxvideo.vue'),
    meta: {
      title: '微信播放器'
    }
  },
  {
    name: 'test/subscribe',
    component: () => import('./pages/test/subscribe.vue'),
    meta: {
      title: '服务号订阅通知'
    }
  },
  {
    name: 'test/store',
    component: () => import('./pages/test/store.vue'),
    meta: {
      title: '实验室-Vuex'
    }
  }
];

// add route path
routes.forEach(route => {
  route.path = route.path || util.urlPrefix+'/' + (route.name || '');
});

const router = new Router({ routes,mode: 'history'});

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }

  var ua = navigator.userAgent.toLowerCase();
  var isWeixin = ua.indexOf('micromessenger') != -1;
  if (!isWeixin && to.path.indexOf('we_chat_back/index') == -1 &&0) {
    location.href =util.urlPrefix+'/we_chat_back/index?redirect_uri='+decodeURIComponent(location.href);
    return false;
  }

  console.log('to',to);
  console.log('from',from);
  // 检查是否要跳转云就业单点授权
  if(to.name!='yjy/authorization'){
    if(util.G_CONFIG && util.G_CONFIG.yjy_school && util.G_CONFIG.yjy_school.yjy_token){
      console.log("需要进行云就业授权")
      let local_user = util.globalData.user.get()
      if(local_user && local_user.yjy_xh==''){
       console.log("未进行绑定,跳转到单点登录")
       location.href =util.urlPrefix+'/yjy/authorization?token='+util.token+'&type=1&source_url='+decodeURIComponent(location.href);
       return false;
      }
   }
  }
  


  
  if(to.name=='test/index' || 1){
    console.log('路由匹配test/index，执行登录测试');
    
    var session_id = ''
    if($cookies.get('session_id')){
        session_id = $cookies.get('session_id');
    }

    console.log('util.sessionid.get()', util.sessionid.get())
    if(process.env.NODE_ENV=='development'){//如果是开发环境，直接设置 session
        session_id = env.base_config.sessionID
        $cookies.set('session_id', session_id)
        console.log('测试环境,从配置文件中获取token, cookie中设置session_id')
    }

    // 获取得到sessionId,则执行数据更新，说明刚刚进行授权
    if(session_id){
        console.log("执行session操作及获取用户")
        util.sessionid.set(session_id)
        util.setUserProfile()

        
        $cookies.remove('session_id')
    }else{
        console.log("没有session_id，不做任何执行")
    }
    
    console.log("判断测试用户")
    util.set_gate_users()
  }else{
    console.log('路由不匹配不执行');
  }
  next();
});

export {
  router
};
